<script>
import UsersApi from "@/services/users-api";
import simplebar from "simplebar-vue";
import ItemsApi from "@/services/items-api";
import ClaimApi from "@/services/claim-api";

export default {
    components: {
        simplebar
    },
    mounted(){
        if(this.isClaimTypeEnabled){
            this.getClaimsServices();

        }
        this.getTraders();
        this.getAllBrands();

    },
    computed: {
        adminPermission() {
          return this.getPermission("SUPPLIER_ADMIN");
        },
        nonAdminSupplierPermissionGroupes() {
            if(!this.isClaimTypeEnabled){
                return this.supplierPermissionGroupes.filter(element =>  ( element.IsVisible  == null || element.IsVisible== false) && (  element.id !== 4 && element.id !== 5));
            }
            return this.supplierPermissionGroupes.filter(element =>  element.IsVisible  == null || element.IsVisible== false);
        },
        isClaimTypeEnabled(){
          return  process.env.VUE_APP_FEATURE_CLAIM_TYPE === 'true'
        },

            
        filterByAgency() {
        return this.agencyList && this.agencyList.length > 1;
        },

        agencyList() {
        try {
            return JSON.parse(process.env.VUE_APP_FEATURE_AGENCY_LIST || "[]");
        } catch (e) {
            return [];
        }
        },
    },
    data(){
        return{
            pagemodelMain: {currentPage : 1, perPage : 10, totalRows: 0},
            usersFilter:null,
            isUsersTableBusy:false,
            usersListFields: 
                [
                    { key:"name", label: "Nom",   sortable: false, tdClass:"font-weight-bold  ",},
                    { key:"jobTitle", label: "Fonction",thClass:"",tdClass:"" },
                    { key:"service", label: "",thClass:"",tdClass:"" },
                    { key:"userName", label: "Login",thClass:"",tdClass:"" },
                    { key:"password", label: "Mot de passe",thClass:"",tdClass:"" },
                    
                    // { key:"clients", label: "Clients",thClass:"text-center", tdClass:"text-center"},
                    { key:"isPartner", label: "Partenaire",thClass:"text-center", tdClass:"text-center"},
                    { key:"isAdmin", label: "Admin",   thClass:"text-center", tdClass:"text-center"},
                    { key:"status", label: "Statut",   thClass:"text-center", tdClass:"text-center"},
                    { key:"actions", label:""}
                ],
            selectedUser:{id:'',name:'',userName:'',password:'',supplierId:null,status:1, extSystemId:'',brands:[],permission:[],isPartner:false, partnerCode: null,service:null,agencyDbId:null},
            brandsList:[],
            servicesList:[],
            showPasswordModal:false,
            passwordHidden:true,
            newPassword:null,
            showClientsModal:false,
            clientsList:[],
            pagemodelCustomersList: {currentPage : 1, perPage :10, totalRows: 0},
            customersListFields: 
                [   
                    { key:"selection",label:"",thClass:"text-center align-middle", tdClass:"text-left align-middle"},
                    { key:"companyName", label: "",   sortable: false, thClass:"text-center align-middle", tdClass:"font-weight-bold align-middle ",},
                    { key:"extId", label: "",   sortable: false, thClass:"text-center align-middle", tdClass:" align-middle ",},
                    { key:"country.name", label: "",   sortable: false,thClass:"text-center align-middle", tdClass:"align-middle",},
                    { key:"city.name", label: "",   sortable: false ,thClass:"text-center align-middle", tdClass:" align-middle",},
                ],
            customersListFieldsForAdmin: 
                [
                    { key:"companyName", label: "",   sortable: false, tdClass:"font-weight-bold ",},
                    { key:"country.name", label: "",   sortable: false, tdClass:"font-weight-bold ",},
                    { key:"city.name", label: "",   sortable: false, tdClass:"font-weight-bold ",},
                ],
            customerTableBusy:false,
            selectedCustomer:new Set(),
            editUsersModal:false,
            isNew:false,

            
            // selectedUserPriviligesList:[],
            // selectedUserPriviligesListFields: 
            //     [
            //         { key:"fullName", label: "",   sortable: false, tdClass:"font-weight-bold ",},
            //         { key:"actions", label:"",thClass:"text-right", tdClass:"text-right"}
            //     ],
            allCustomersAreSelected:0,
            editSelectionStaring:false,
            customersFilter:null,

            tradersList: [],
            supplierPermissionGroupes:[
                { id: 0, label: "Administrateur BackOffice",isSelected: 0 ,permission:"SUPPLIER_ADMIN" ,IsVisible: true},
                { id: 1, label: "Ajout des nouvelles Commandes" ,isSelected: 0 ,permission:"SUPPLIER_ADD_ORDER"},
                { id: 2, label: "Accès aux documents" ,isSelected: 0 ,permission:"SUPPLIER_DOCUMENT_ACCESS"},
                { id: 3, label: "Ajout des nouvelles réclamations",isSelected: 0 ,permission:"SUPPLIER_ADD_CLAIM"},
                { id: 4, label: "Liste des réclamations (par service)",isSelected: 0 ,permission:"SUPPLIER_CLAIM_LIST"},
                { id: 5, label: "Liste des réclamations globales",isSelected: 0 ,permission:"SUPPLIER_CLAIM_SERVICE_MANAGER"},
            ],
            
        }
    },

    watch: {
        nonAdminSupplierPermissionGroupes() {
            return this.supplierPermissionGroupes.filter(element =>  !element.IsVisible );
        },
    },
    methods:{
        getPermission(permission) {
            const foundElement = this.supplierPermissionGroupes.find(element => element.permission === permission);
            return foundElement || null;
        },
        onAdminChange() {
            this.selectedUser.isPartner = false;
            this.selectedUser.permission=[]
        },
        onPartnerChange() {
            const adminPermission = this.getPermission("SUPPLIER_ADMIN");
            if (adminPermission) {
                adminPermission.isSelected = 0;
            }
            this.selectedUser.permission=[]
        },
        getClaimsServices(){
            ClaimApi.getServicesCount().then(
                result => {
                    if(result){
                        ClaimApi.getClaimsServices(null,result,null,false).then(
                            response => {    
                            this.servicesList = response.list;
                        })
                    }
                }
            )
        },
        getAllBrands(){
            ItemsApi.getAllBrands().then(
                result => {
                if(result) {
                    this.brandsList=result;
                }
                }
            )
        },

        getTraders(){
            this.isUsersTableBusy = true;
            UsersApi.getTraders(this.pagemodelMain.currentPage, this.pagemodelMain.perPage,this.usersFilter).then(
                  response => {    
                    this.tradersList= response.list
                    this.pagemodelMain.totalRows = response.total;
                    this.pagemodelMain.currentPage = response.page;
                    this.pagemodelMain.perPage = response.pageSize;
                    this.pagemodelMain.pageSize = response.pageSize;
                  }
              ).finally(() => {
             this.isUsersTableBusy = false;
                });
        },
        showHidePassword(){
            this.passwordHidden=!this.passwordHidden
        },
        changePassword(user){
            this.selectedUser=user
            this.passwordHidden=true
            this.newPassword=null
            this.showPasswordModal=true
        },
        updatePassword(){
            UsersApi.updatePassword(this.selectedUser.id,this.newPassword).then(
                (result)=>{
                    if(result){
                        this.showPasswordModal=false
                        this.selectedUser={}
                    }
                }
            )
        },

        getTradersClients(){
            this.customerTableBusy=true
            UsersApi.getTradersClients(this.pagemodelCustomersList.currentPage,this.pagemodelCustomersList.perPage,this.selectedUser==null ? null : this.selectedUser.id,this.customersFilter).then(
                (result)=>{
                    if(result){
                        this.clientsList=result.list
                        this.pagemodelCustomersList.totalRows = result.total;
                        this.pagemodelCustomersList.currentPage = result.page;
                        this.pagemodelCustomersList.perPage = result.pageSize;
                        this.pagemodelCustomersList.pageSize = result.pageSize;
                        var addedToTraderCount=0;
                        for(const i in this.clientsList){
                            if(this.clientsList[i].isAddedToTrader==1){
                                addedToTraderCount++;
                            }  
                        }
                        if(addedToTraderCount == this.pagemodelCustomersList.pageSize ){
                            this.allCustomersAreSelected = 1
                        }else{
                            this.allCustomersAreSelected = 0
                        }
                    }
                }
            ).finally(()=>{
                this.showClientsModal=true
                this.customerTableBusy=false
            })
        },

       

        addNewTrader(){
            this.selectedUser={id:'',name:'',userName:'',password:'',supplierId:null,status:1, extSystemId:'',brands:[],permission:[],isPartner:false,service:null,agencyDbId:null},
            this.cancelUserEdit()
            this.isNew=true
            this.passwordHidden=true
            this.editUsersModal=true
        },

        cancelUserEdit(){
            this.supplierPermissionGroupes.forEach(p => {
                p.isSelected = 0 ;
            })           
            this.nonAdminSupplierPermissionGroupes.forEach(p => {
                p.isSelected = 0 ;
            })  
            this.selectedUser.brands=[];
            this.selectedUser.permission=[];
            this.selectedUser.status=1;
            this.selectedUser.isAdmin = false
            this.selectedUser.id=null
            this.selectedUser.name=''
            this.selectedUser.userName=''
            this.selectedUser.password=''
            this.selectedCustomer.extSystemId=''
            this.selectedUser.isPartner = false
            this.selectedUser.partnerCode=null
            this.selectedUser.agencyDbId=null
            this.editUsersModal = false
        },

        saveUser(){

            

            this.selectedUser.supplierId= null
            this.selectedUser.customerId= null
            const adminPermission = this.getPermission("SUPPLIER_ADMIN");
            if (adminPermission ) {
                if(adminPermission.isSelected == 0 ){
                    this.selectedUser.isAdmin = false;
                }else if(adminPermission.isSelected == 1 && this.selectedUser.isPartner == false){
                    this.selectedUser.isAdmin = true ;
                }
            }
            UsersApi.saveUser(this.selectedUser).then(
                (result)=> {
                    if(result){
                        this.getTraders()          
                        this.cancelUserEdit()
                        this.editUsersModal=false
                    }

                }
            )
        },

        editUser(user){
            this.selectedUser.id=user.id
            this.selectedUser.status=user.status
            this.selectedUser.isAdmin=user.isAdmin
            this.selectedUser.name=user.name
            this.selectedUser.userName=user.userName
            this.selectedUser.phone=user.phone
            this.selectedUser.service= user.service 
            this.selectedUser.jobTitle=user.jobTitle
            this.selectedUser.extSystemId=user.extSystemId;
            this.selectedUser.isPartner=user.isPartner;
            this.selectedUser.partnerCode=user.partnerCode
            this.selectedUser.brands = user.brands ;
            this.selectedUser.agencyDbId = user.agencyDbId ;
            if(this.selectedUser.isAdmin == false ){
                const adminPermission = this.getPermission("SUPPLIER_ADMIN");
                if (adminPermission ) {
                    adminPermission.isSelected = 0;
                }
                if(this.selectedUser.isPartner == false){
                    // not partner and not admin
                    this.selectedUser.permission =user.permission
                    const selectedPermissions = user.permission || [];
                    this.nonAdminSupplierPermissionGroupes.forEach(p => {
                        p.isSelected = selectedPermissions.includes(p.permission) && !p.IsVisible ? 1 : 0;
                    });
                }else{
                    //partner
                    this.selectedUser.permission =[]
                    this.nonAdminSupplierPermissionGroupes.forEach(p => {
                        p.isSelected = 0;
                    });
                }
                
            }else if(this.selectedUser.isAdmin == true){
                //Admin
                this.selectedUser.permission =[]
                this.nonAdminSupplierPermissionGroupes.forEach(p => {
                    p.isSelected = 0 ;
                })   
                this.supplierPermissionGroupes.forEach(p => {
                    p.isSelected = 0 ;
                })
                const adminPermission = this.getPermission("SUPPLIER_ADMIN");
                if (adminPermission ) {
                    adminPermission.isSelected = 1;
                }
            }
            this.isNew=false
            this.editUsersModal=true
        },



        editSelection(item){
            
            if(this.selectedUser.hasAdminPrivilege){
                return;
            }

            if(item == null){
                return;
            }
            
            this.editSelectionStaring=true

            let array = [];
            array.push(item.id)
            UsersApi.editSelection(array ,this.selectedUser==null ? null : this.selectedUser.id).then(
                (result)=>{
                    if(result){
                        this.getTradersClients(this.selectedUser)
                    }
                }
            ).then(
                ()=>{
                    this.editSelectionStaring=false
                }
            )
        },

        selectAllCustomers(){
            if(this.selectedUser.hasAdminPrivilege){
                return;
            }

            let array = [];

            for(const i in this.clientsList){
                array.push(this.clientsList[i].id)
            }

            UsersApi.editSelection(array ,this.selectedUser==null ? null : this.selectedUser.id).then(
                (result)=>{
                    if(result){
                        this.getTradersClients(this.selectedUser)
                    }
                }
            )

        },

        openClientsModal(user){
            this.selectedCustomer= new Set()
            this.pagemodelCustomersList= {currentPage : 1, perPage :10, totalRows: 0}
            this.selectedUser=user
            this.getTradersClients(user);

        },

        onClientsModalClose() {
            this.getTraders();
        }
        
        },


}
</script>

<template>
    <div>
        <div class="row mt-4 pt-4 pb-4">
            <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
                <b-form-group>
                    <b-input-group  >
                        <b-form-input :placeholder="$t('traders.nameFilter')"   v-model="usersFilter"   @keyup.native.enter="getTraders() "
                            ></b-form-input>                              
                        <template v-slot:append>
                            <b-button variant="primary" @click="getTraders()" >
                            <i class="bx bx-search-alt font-weight-bold font-size-16 text-white align-middle"></i>
                            </b-button>
                        </template>
                    </b-input-group>
                </b-form-group>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">


                <b-button variant="outline-primary" @click="addNewTrader()" class="mb-4 float-right">
                    <i class="  fas fa-plus-square font-size-16 font-weight-bold align-middle mr-2 "></i> 
                    <span class="  font-weight-bold">
                       {{$t('traders.addNew')}}  
                    </span>
                </b-button>
            </div>
        </div>
        <div class="table-responsive"> 
            <b-table 
            :busy="isUsersTableBusy"
            :striped="true"
            :small="false"
            :hover="true"
            :items="tradersList"
            :fields="usersListFields"
            :perPage="pagemodelMain.perPage"
            class="table  "
            >
            <template v-slot:table-busy>
                <div class="text-center my-2">
                    <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
                </div>
            </template>
            <template v-slot:head(name)>
                {{ $t("traders.table.name") }} 
            </template>
            <template v-slot:head(service)>
                <span v-if="isClaimTypeEnabled">{{ $t("traders.table.service") }} </span>
            </template>
            <template v-slot:head(jobTitle)>
                {{ $t("traders.table.jobTitle") }} 
            </template>
            <template v-slot:head(userName)>
                {{ $t("traders.table.userName") }} 
            </template>
            <template v-slot:head(password)>
                {{ $t("traders.table.password") }} 
            </template>
            <template v-slot:head(status)>
                Actif
            </template>
            <!-- <template v-slot:head(clients)>
                {{ $t("traders.table.clients") }} 
            </template> -->
            <!-- <template v-slot:head(privileges)>
                {{ $t("traders.table.privileges") }} 
            </template> -->
            <template v-slot:cell(password)="{item}">
                <b-button @click="changePassword(item)"  size="sm" variant="outline-dark"  >
                    <i class="fas fa-key font-size-16 align-middle mr-md-2"></i><span class="d-none d-md-inline">{{$t('traders.changePassword')}}</span>
                </b-button>
            </template>
            <template v-slot:cell(status)="{value}">
                <i :class="value===1 ? 'fas fa-check text-success' : 'fas fa-ban text-danger' " ></i>
            </template>
            <template v-slot:cell(isPartner)="{value}">
                <i :class="value ? 'fas fa-regular fa-handshake font-size-14 text-primary' : '' " ></i>
            </template>

            <template v-slot:cell(isAdmin)="{value}">
                <i :class="value ? 'fas fa-user-graduate font-size-18 text-success' : 'fas fa-user-alt-slash text-danger' " ></i>
            </template>
            <template v-slot:cell(service)="{value}">
                <span v-if="isClaimTypeEnabled">{{value ? value.name : "_"}}</span>
            </template>
            <template v-slot:cell(jobTitle)="{value}">
                {{value ? value : "_"}}
            </template>
            <!-- <template v-slot:cell(clients)="{item}">
                <span :class=" item.isAdmin ? 'text-success font-weight-bold' :  item.isPartner ? 'text-primary font-weight-bold': 'text-muted'" @click="openClientsModal(item)" style="cursor:pointer">
                    <i class="fas fa-user-cog  mr-2"  ></i> 
                      {{ item.customersCount }} client(s)
                </span>


            </template> -->
            <!-- <template v-slot:cell(privileges)="{item}">
                <i class="fas fa-user-lock text-primary font-size-18" @click="getTradersPriviliges(item)" style="cursor:pointer" ></i>
            </template> -->
            <template v-slot:cell(actions)="{item}">
                <a  title="modifier" href="javascript:void(0);"  @click="editUser(item)" class="action-icon text-warning pr-2" >
                    <i class="fas fa-pencil-alt font-size-16"  />
                </a>
            </template>

            </b-table>
            <span v-if="!isUsersTableBusy && tradersList && !tradersList.length" class="d-flex justify-content-center m-4 text-danger" >{{$t('traders.table.empty')}} </span>

        </div>
        <!-- Pagination -->
        <div class="row pt-3 mb-sm-4">
            <div class="col-sm-8">
                <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                    <b-form-select @input="getTraders()"  v-model="pagemodelMain.perPage" size="sm" style="width: 60px" :options="[10,15,50,100]"></b-form-select>
                    <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">{{ $t("pagination.from") }}</span><span class="font-weight-bold"> {{pagemodelMain.totalRows}} {{ $t("pagination.lines") }}</span></div>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="pagemodelMain.currentPage" :disabled="isUsersTableBusy" :per-page="pagemodelMain.pageSize" :total-rows="pagemodelMain.totalRows" @input="getTraders()" ></b-pagination>
                    </ul>
                </div>
            </div>
        </div> 
        <!-- Fin Pagination  -->
        <b-modal
            v-model="showPasswordModal"
            :title="$t('traders.passwordModal.title')+selectedUser.name" 
            hide-footer 
            centered 
            title-class="text-primary"
            title-tag="h5"
            header-close-variant="danger"
        >
            <div class="form-group row">
                <label class="col-5 col-form-label" for="pwd">{{$t('traders.passwordModal.label')}} </label>
                <div class="col-5">
                        <b-input-group >
                          <b-form-input v-model="newPassword"  @keyup.native.enter="updatePassword()" :type="passwordHidden ? 'password':'text'" ></b-form-input>
                            
                          <template v-slot:append>
                              <b-button  size="sm" variant="dark"   >
                                <i :class="passwordHidden ?'fa fa-eye-slash':'display-eye fa fa-eye'" @click="showHidePassword ()" ></i>
                              </b-button>
                          </template> 
                        </b-input-group>
                </div>
                <div class="col-1"/>
                <div class="col-1">
                    <b-button variant="success" @click="updatePassword()">
                        <i class="fas fa-save font-size-14 align-middle  " ></i>
                    </b-button>
                </div>
            </div>

        </b-modal>

        <b-modal
                v-model="editUsersModal"
                :title="selectedUser.id ? $t('traders.editUsersModal.title1') : $t('traders.editUsersModal.title2') " 
                centered 
                title-class="text-primary"
                title-tag="h5"
                header-close-variant="danger"
                size="lg"
                no-close-on-backdrop
        >

            <div class="row">

                <div class="col-12 col-sm-6">
                    <div class="float-left">
                        <div  class="form-group  ">
                            <b-form-checkbox
                                value="1"
                                unchecked-value="0"
                                class="custom-checkbox custom-checkbox-outline custom-checkbox-success mb-0 mt-0"
                                v-model="selectedUser.status"
                                >   
                                <span class="font-size-14" :class="selectedUser.status == 1 ? 'text-info' : 'text-muted'">{{selectedUser.status == 1 ? $t('traders.editUsersModal.status.active') : $t('traders.editUsersModal.status.disabled')}}</span>
                            </b-form-checkbox>
                        </div>
                    </div>
                </div>

                <div v-if="filterByAgency" class="col-sm-6 col-xs-12">
                     <b-form-group :label="$t('traders.editUsersModal.agency.label')" label-for="">
                        <v-select class="style-vselect" 
                            style="font-size:1.2em;" 
                            :options="agencyList" 
                            :placeholder="$t('traders.editUsersModal.agency.placeholder')" 
                            label="name"
                            :reduce="option => option.id"
                            v-model="selectedUser.agencyDbId"
                            :disabled="selectedUser.isPartner == true">
                        <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                        </v-select>
                    </b-form-group>
                </div>
                
            </div>


            <div class="row"> 
                <div class="col-sm-6 col-xs-12">
                    <div class="float-left">
                        <div  class="form-group  ">
                            <b-form-checkbox
                                :value="1"
                                :unchecked-value="0"
                                class="custom-checkbox custom-checkbox-outline custom-checkbox-success mb-0 mt-0"
                                v-model="getPermission('SUPPLIER_ADMIN').isSelected"
                                @change="onAdminChange"
                                >   
                                <span class="font-size-14" :class="adminPermission.isSelected == 1 ? 'text-info' : 'text-info'">{{adminPermission.isSelected == 1 ? 'Administrateur' :  'Administrateur' }}</span>
                            </b-form-checkbox>
                             <small
                                v-if="this.adminPermission.isSelected == 1 && this.selectedUser.agencyDbId"
                                class="text-danger d-block mt-1"
                                style="max-width: 300px;"
                            >
                                L’affectation d’une agence à un administrateur peut restreindre certaines permissions.
                            </small>
                        </div>
                    </div>
                </div>
                
                    
                <div class="col-sm-6 col-xs-12 pr-2"> 
                    <b-form-group :label="$t('traders.editUsersModal.supplierAccessList.label')" label-for="">
                        <v-select class="style-vselect" 
                            style="font-size:1.2em;" 
                            :options="nonAdminSupplierPermissionGroupes" 
                            :placeholder="$t('traders.editUsersModal.supplierAccessList.label')" 
                            multiple  
                            label="label" 
                            v-model="selectedUser.permission" 
                            :reduce="option => option.permission"
                            :disabled="adminPermission.isSelected == 1 || selectedUser.isPartner == true">
                        <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                        </v-select>
                    </b-form-group>
                </div>
            </div>
            <div class="row"> 

                <div class="col-sm-6 col-xs-12">
                        <div class="float-left">
                            <div  class="form-group  ">
                                <b-form-checkbox
                                    :value=true
                                    :unchecked-value=false
                                    class="custom-checkbox custom-checkbox-outline custom-checkbox-success mb-0 mt-0"
                                    v-model="selectedUser.isPartner"
                                    @change="onPartnerChange"
                                    > 
                                    <span class="font-size-14" :class="selectedUser.isPartner == true ? 'text-info' : 'text-muted'" > {{$t('traders.editUsersModal.partenaire')}}</span>
                                </b-form-checkbox>
                            </div>
                        </div>
                    </div>
                    
                    <div class="col-sm-6 col-xs-12 pr-2"> 
                        <b-form-group :label="$t('traders.editUsersModal.supplierList.label')" label-for="">
                            <v-select class="style-vselect" style="font-size:1.2em;" :options="brandsList" :placeholder="$t('traders.editUsersModal.supplierList.label')" multiple  label="name" v-model="selectedUser.brands" :disabled="selectedUser.isPartner == false">
                            <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                            </v-select>
                        </b-form-group>

                        <div class="form-group pr-2 w-100">
                            <label >Code Partenaire (dans ERP)</label>
                            <input :disabled="selectedUser.isPartner == false"  :style="selectedUser.isPartner == false ? 'background-color:rgb(248, 248, 248)' : ''"
                            type="text"
                            class="form-control"
                            v-model="selectedUser.partnerCode"
                            />
                </div>

                    </div>
            </div>

            

            

            <div class="row mt-4" style="width:100%">
                <div class="form-group col-sm-4 pr-2">
                    <label >{{$t('traders.editUsersModal.table.name')}} </label>
                    <input
                    type="text"
                    class="form-control"
                    v-model="selectedUser.name"
                    />
                </div>
                <div class="form-group col-sm-4 pr-2">
                    <label >{{$t('traders.editUsersModal.table.userName')}} </label>
                    <input
                    type="text"
                    class="form-control"
                    v-model="selectedUser.userName"

                    />
                </div>
                <div v-if="isNew" class="form-group col-sm-4 pr-2">
                    <label >{{$t('traders.editUsersModal.table.password')}}</label>
                    <form autocomplete="off">
                        <div class="input-group">
                            <input class="form-control" :type="passwordHidden ? 'password':'text'" autocomplete="new-password" v-model="selectedUser.password">
                            <div class="input-group-append">
                                <span class="input-group-text"><i :class="passwordHidden ?'fa fa-eye-slash':'display-eye fa fa-eye'" @click="showHidePassword" ></i></span>
                            </div>
                        </div>
                    </form>
                </div>

               

                <div class="form-group col-sm-4 pr-2">
                    <label >{{$t('traders.editUsersModal.table.phone')}}</label>
                    <input
                    type="text"
                    class="form-control"
                    v-model="selectedUser.phone"

                    />
                </div>
                <div class="form-group col-sm-4 pr-2">
                    <label >{{$t('traders.editUsersModal.table.jobTitle')}}</label>
                    <input
                    type="text"
                    class="form-control"
                    v-model="selectedUser.jobTitle"

                    />
                </div>
                <div v-if="isClaimTypeEnabled" class="form-group col-sm-4 pr-2"/>
                <div v-if="isClaimTypeEnabled" class="form-group col-sm-8 pr-2">
                    <b-form-group :label="$t('traders.table.service')" label-for="">
                        <v-select class="style-vselect" style="font-size:1.2em;" :options="servicesList" :placeholder="$t('traders.table.service')" 
                          label="name" v-model="selectedUser.service" >
                        <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                        </v-select>
                    </b-form-group>
                </div>
              
                

            </div>

            <template v-slot:modal-footer>
            <b-button variant="secondary" @click="cancelUserEdit()" size="md">{{$t('buttons.cancel')}}</b-button>
            <b-button  variant="danger" @click="saveUser()" size="md" ><span class="text-white font-weight-bold">{{$t('buttons.save')}}</span></b-button>
            </template>

        </b-modal>
       

        <b-modal
            v-model="showClientsModal"
            :title="$t('traders.tradersCustomersModal.title')+selectedUser.name" 
            hide-footer 
            centered 
            title-class="text-primary"
            title-tag="h5"
            header-close-variant="danger"
            no-close-on-backdrop
            size="lg"

            @hide="onClientsModalClose()">

        <b-form-group :label="$t('traders.tradersCustomersModal.nameFilter.label')" >
            <b-input-group  >
                <b-form-input :placeholder="$t('traders.tradersCustomersModal.nameFilter.placeholder')"   v-model="customersFilter"   @keyup.native.enter="getTradersClients() "
                    ></b-form-input>                              
                <template v-slot:append>
                    <b-button variant="danger" @click="getTradersClients()" >
                    <i class="bx bx-search-alt font-weight-bold font-size-16  align-middle"></i>
                    </b-button>
                </template>
            </b-input-group>
        </b-form-group>
        <span v-if="!customerTableBusy & !clientsList.length" class="d-flex justify-content-center m-4 text-danger" > {{$t('traders.tradersCustomersModal.table.empty')}} </span>
        <simplebar  style="max-height: 25em;min-height: 25em;"  >

            <div class="table-responsive" style="max-height: 25em;min-height: 25em;" > 
                    <b-table 
                    :busy="customerTableBusy"
                    :striped="true"
                    :small="true"
                    :hover="true"
                    :items="clientsList"
                    :fields="selectedUser.hasAdminPrivilege ? customersListFieldsForAdmin :customersListFields"
                    :perPage="pagemodelCustomersList.perPage"
                    class="table  "
                    thead-class="d-none"
                    id="my-table"
                    >
                        <template v-slot:table-busy>
                            <div class="text-center my-2">
                                <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
                            </div>
                        </template>

                        <template v-slot:head(companyName)>
                            {{ $t("traders.tradersCustomersModal.table.name") }} 
                        </template>
                        <template v-slot:head(country)>
                            {{ $t("traders.tradersCustomersModal.table.country") }} 
                        </template>
                        <template v-slot:head(city)>
                            {{ $t("traders.tradersCustomersModal.table.city") }} 
                        </template>

                        <!-- <template v-slot:cell(companyName)="{item, value}">
                            <code>{{item.code}}</code> {{ value }}
                        </template> -->

                        <template v-slot:cell(selection)="{item}">
                        <b-form-checkbox
                            value="1"
                            unchecked-value="0"
                            class="custom-checkbox-success "
                            v-model="item.isAddedToTrader"
                            @input="editSelection(item)"
                            :disabled="editSelectionStaring"
                            ></b-form-checkbox>
                        </template>
                    </b-table>
            </div>

        </simplebar>

           <!-- Pagination -->
        <div class="row pt-3 mb-sm-4">
            <div class="col-sm-8">
                <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                    <b-form-select @input="getTradersClients(selectedUser)"  v-model="pagemodelCustomersList.perPage" size="sm" style="width: 60px" :options="[10,15,50,100]"></b-form-select>
                    <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">{{ $t("pagination.from") }}</span><span class="font-weight-bold"> {{pagemodelCustomersList.totalRows}} {{ $t("pagination.lines") }}</span></div>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="pagemodelCustomersList.currentPage" :disabled="customerTableBusy" :per-page="pagemodelCustomersList.pageSize" :total-rows="pagemodelCustomersList.totalRows" @input="getTradersClients(selectedUser)" ></b-pagination>
                    </ul>
                </div>
            </div>
        </div> 
        <!-- Fin Pagination  -->
        </b-modal>


    </div>
</template>